<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Footer Columns'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Footer Columns',
            includeDeleteAction: false
        };
    },

    computed: {
        options() {
            return {
                addButton: false
            };
        },

        labels() {
            return [
                { value: 'title', width: '150px' },
                { value: 'order', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'footerColumns/index'
        }),

        onRowClick({ id }) {
            this.$router.push(`/footer-columns/${id}/edit`);
        }
    }
};
</script>
